/**
 * These correspond to TaskType#name that we know exist in all backend regions.
 */
export enum TaskTypeNames {
  CUSTOM_TASK = "custom",
  PRODUCT_ISSUE = "productIssue",
  MEDIA_MAINTENANCE_SINGLE_MEDIA = "mediaMaintenanceSingleMedia",
}
